import Link from "next/link";
import { legalLinks } from "../legal-content";

export function SiteHeader() {
  return (
    <div className="nav">
      <Link className="brand logo-brand" href="/" scroll={false} aria-label="Esited home">
        <img src="/images/esited-logo.svg" alt="Esited" />
      </Link>
      <div className="nav-links">
        <Link href="/dedicated-servers" scroll={false}>Dedicated</Link>
        <Link href="/cloud-hosting" scroll={false}>Cloud</Link>
        <Link href="/colocation" scroll={false}>Colocation</Link>
        <Link href="/datacenter" scroll={false}>Datacenter</Link>
        <Link href="/about-us" scroll={false}>About Us</Link>
        <Link href="/contact-us" scroll={false}>Contact Us</Link>
        <label
          className="theme-switch"
          htmlFor="theme-toggle"
          role="button"
          aria-label="Toggle dark mode"
        >
          <span className="theme-knob"></span>
          <span className="theme-text-light">Light</span>
          <span className="theme-text-dark">Dark</span>
        </label>
      </div>
    </div>
  );
}

export function UtilityBar() {
  return (
    <div className="utility">
        <span></span>
      <div className="utility-actions">
        <span>+1 877-551-5358</span>
        <a href="https://magic.esited.com/">Login</a>
        <a href="https://magic.esited.com/">Signup</a>
      </div>
    </div>
  );
}

export function SiteFooter() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="brand logo-brand">
            <img src="/images/esited-logo.svg" alt="Esited" />
          </div>
          <div>Dedicated servers, KVM cloud hosting, colocation, and IP transit, with 24/7 infrastructure support.</div>
        </div>
        <div className="footer-col">
          <h3>Pages</h3>
          <Link href="/dedicated-servers">Dedicated Servers</Link>
          <Link href="/cloud-hosting">Cloud</Link>
          <Link href="/colocation">Colocation</Link>
          <Link href="/datacenter">Datacenter</Link>
          {/* <Link href="/posts">Posts</Link> */}
          <Link href="/about-us">About Us</Link>
          <Link href="/contact-us">Contact Us</Link>
        </div>
        <div className="footer-col">
          <h3>Quick Links</h3>
          {legalLinks.map((link) => (
            <Link href={link.href} key={link.href}>
              {link.label}
            </Link>
          ))}
        </div>
        <div className="footer-col">
          <h3>Contact</h3>
          <span>877-551-5358</span>
          <span>support@esited.com</span>
          <span>600 W 7th Street, Suite #140</span>
          <span>Los Angeles, CA 90017, United States</span>
        </div>
      </div>
      <div className="footer-bottom">
        <span>Copyright 2026 Esited. All rights reserved.</span>
      </div>
    </footer>
  );
}
